export class AusschlussKriterien {
  baufiLetzteZweiJahre: boolean;

  constructor(ausschlussKriterien?: AusschlussKriterien) {
    this.baufiLetzteZweiJahre = ausschlussKriterien ? ausschlussKriterien.baufiLetzteZweiJahre : null;
  }
}
